import React, {useEffect, useState} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {Field, Form, Formik} from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import AjaxLoading from '../AjaxLoading'
import Trigger from './Trigger'


import {_t} from './../../i18n/lang';

import {lStorage, lStorageKeys} from '../../helpers/lStorage';
import { adminToolsService } from "../../services/adminToolsService";


const useStyles = makeStyles({
    adminListToolsClosed: {
        maxHeight: '0',
        transition: 'max-height 0.15s ease-out',
        overflow: 'hidden',
        background: '#d5d5d5',
    },

    adminListToolsOpen: {
        maxHeight: '500px',
        transition: 'max-height 0.5s ease-in',
    },
});

export default function AdminTools(props) {
    const classes = useStyles();
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const [userSearchPanelFlag, setUserSearchPanelFlag] = useState(false)
    const [userSearchPhrase, setUserSearchPhrase] = useState('')
    const [usersOption, setUsersOption] = useState([])

    const [mfgId, setMfgId] = useState(props.user.addr)

    const handleClick = () => {
        setOpen(!open)
    }

    const handleUserSearchTrigger = () => {
        setUserSearchPanelFlag(!userSearchPanelFlag)
    }

    const handleUserSearchChange = (e) => {
        setUserSearchPhrase(e.target.value)
    }

    const handleMfgIdSearch = (e) => {
        const value = e.target.value.trim()
        if (value.length === 8) {
            setLoading(true)
            adminToolsService.clientUsers(value).then(data => {
                setUsersOption(data.users)
                setLoading(false)
            });
        }
        setMfgId(value)
    }

    useEffect( () => {
        setLoading(true)
        adminToolsService.clientUsers(mfgId).then(data => {
            setUsersOption(data.users)
            setLoading(false)
        });
    }, [])

    const displayForm = () => {
        return (
            <Formik
                initialValues={{
                    mfgId: '',
                    user: 0
                }}
                onSubmit={(values) => {
                    lStorage.set('userContext', JSON.stringify({mfgId: mfgId, user: values}));
                }}
                render={(values, isSubmitting) => (
                    <Form style={{position: 'relative'}}>
                        {loading && (
                            <AjaxLoading />
                        )}
                        <div className="row form-row mt-2" style={{padding: '0 5px'}}>
                            <div className="input-group input-group-sm">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">{_t("AT_MFG_ID")}</span>
                                </div>
                                <Field className="form-control"
                                       as="input"
                                       component="input"
                                       type="text"
                                       name="mfgId"
                                       value={mfgId}
                                       placeholder="MFG ID"
                                       onChange={handleMfgIdSearch}
                                />
                            </div>
                        </div>

                        <div className={userSearchPanelFlag ? classes.adminListToolsOpen : classes.adminListToolsClosed}>
                            <div className="row form-row mt-2" style={{padding: '0 5px'}}>
                                <div className="input-group input-group-sm">
                                    <Field as="input"
                                           type='text'
                                           placeholder={_t("AT_SEARCH")}
                                           component="input"
                                           value={userSearchPhrase}
                                           name="user_search"
                                           onChange={handleUserSearchChange}
                                           className='form-control'
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row form-row mt-2" style={{padding: '0 5px'}}>
                            <div className="input-group input-group-sm">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">{_t("AT_USER")}</span>
                                </div>
                                <Field as="select" component="select" name="user" className="form-control">
                                    {usersOption.filter((row) => {
                                        return userSearchPhrase.length > 0
                                            ? row.login.indexOf(userSearchPhrase) > -1 || row.lastname.indexOf(userSearchPhrase) > -1
                                            : true
                                    }).map((row) => {
                                        return (
                                            <option key={row.id} value={row.id}>{row.name} {row.lastname} ({row.login})</option>
                                        )
                                    })}
                                </Field>
                                <div className="input-group-append" onClick={handleUserSearchTrigger}>
                                    <span className="input-group-text" style={{cursor: 'pointer'}}>
                                        <FontAwesomeIcon icon={faSearch} style={{marginLeft: '2px'}} />
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="row form-row mt-2 flex-column align-items-end" style={{padding: '0 5px'}}>
                            <button type="submit" className="btn btn-sm  btn-primary" disabled={isSubmitting}>
                                {_t("SUBMIT")}
                            </button>
                        </div>
                    </Form>
                )}
            />
        )
    }

    return (
        <div style={{margin: '0.2em 0.5em'}}>
            <Trigger onClick={handleClick} panelState={open} mfgId={props.user.addr}/>
            <div className={open ? classes.adminListToolsOpen : classes.adminListToolsClosed}>
                {displayForm()}
            </div>
        </div>
    )
}